<section class="bg-gray-50 dark:bg-gray-900">
  <div
    class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
  >
    <a
      href="#"
      class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
    >
      @if (themeService.darkMode$ | async) {
        <img
          src="/assets/svg/LIQ_DDA_dark.svg"
          class="h-8"
          alt="Flowbite Logo"
        />
      } @else {
        <img
          src="/assets/svg/LIQ_DDA_white.svg"
          class="h-8"
          alt="Flowbite Logo"
        />
      }
    </a>
    <div
      class="w-full flex flex-col gap-1 p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8"
    >
      <h2
        class="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
      >
        Forgot Password
      </h2>
      <label class="text-sm text-gray-400"
        >Please enter your email address, we will send you a reset link.</label
      >
      @if (errorMessage) {
        <div
          class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
          role="alert"
        >
          <h3 class="font-bold">
            Please correct the errors below and try again
          </h3>
          <p>{{ errorMessage }}</p>
        </div>
      }
      <form
        class="space-y-4 lg:mt-5 md:space-y-5"
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="forgotPassword()"
      >
        <div>
          <label
            for="forgotPasswordEmail"
            class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
            >Your email</label
          >
          <input
            type="email"
            name="email"
            id="forgotPasswordEmail"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="name@company.com"
            formControlName="forgotPasswordEmail"
            required
            [ngClass]="{
              'border-red-600 focus:border-red-600 focus:ring-red-600':
                getEmailErrorMessage() !== null,

              'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                getEmailErrorMessage() === null,
            }"
          />
          <div
            class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
            [ngClass]="{
              invisible: getEmailErrorMessage() === null,
            }"
          >
            {{ getEmailErrorMessage() }}
          </div>
        </div>
        <button
          type="submit"
          class="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Send Reset Link
        </button>
        <div
          class="flex items-center justify-center space-x-1 cursor-pointer"
          (click)="backToLogin()"
        >
          <svg
            class="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 12h14M5 12l4-4m-4 4 4 4"
            />
          </svg>
          <a class="font-medium text-gray-600 dark:text-white"
            >Go Back To Login</a
          >
        </div>
      </form>
    </div>
  </div>
</section>
